<template>
  <div class="bg-lightGray" style="padding-top: 100px">
    <div class="container">
      <div class="row">
        <nav area-label="breadcrumb">
          <ol class="breadcrumb" style="font-size: 14px">
            <li class="breadcrumb-item"><a href="/recruit">Home</a></li>
            <li class="breadcrumb-item">
              <a href="/recruit/client-job-dashboard">Dashboard</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Post-job</li>
          </ol>
        </nav>
      </div>
      <div class="row text-center mt-5 mb-0 pt-0">
        <div class="col-md-12 col-sm-12 pl-0 pl-m-3">
          <h1 class="text-left text-dark pt mob_h5 h1st1">Post your jobs</h1>
          <p class="text-left mb-0">Free job posting & hire candidates faster</p>
        </div>
      </div>

      <div class="row mt-0">
        <div class="col-md-12 col-lg-8 pl-0 pl-m-3">
          <div>
            <!-- <div v-if="is_login">
                <p v-if="job_post_remaining > 0">Job postings left: {{job_post_remaining}}</p>
                <p v-else>No package to post jobs. Contact admin at <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a> for subscriptions</p>
              </div> -->
            <form ref="postJob-form">
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <div class="gap10"></div>
                <div class="row mt-0">
                  <!-- <div class="col-lg-12 form-group">
                    <label for="title" style="font-size:15px;">Job title<span style="color:red;">*</span></label>
                    <v-autocomplete v-model="toPost.jobs.job_designation" @input="getJobRole" :items="designations" item-text="text" item-value="id" :class="{'is-invalid':typeof validate.response.jobTitle != 'undefined' && !validate.response.jobTitle.val}" clearable outlined ></v-autocomplete>
                    <div class="invalid-feedback" v-if="(typeof validate.response.jobTitle != undefined && can_post !=0 )">
                        {{ validate.response.jobTitle.msg }}
                    </div>
                  </div> -->
                  <div class="col-lg-12 pt-0 inputStyle">
                    <label for="title">Job title<span style="color: red">*</span></label>
                    <v-text-field id="job_title" v-model="toPost.jobs.job_designation" type="text" placeholder="Select Title" list="designations" @input="getJobRole" outlined clearable></v-text-field>
                    <datalist id="designations">
                      <option :key="item.value" v-for="item in designations">{{ item.text }}</option>
                    </datalist>
                    <div class="job_error" v-if="!toPost.jobs.job_designation && can_post != 0">Select Job title</div>
                  </div>
                </div>
                <div class="row mt-2 form-label-group" style="display: none">
                  <div class="col-lg-6 pt-0 pb-0">
                    <label for="title">jobs role<span style="color: red">*</span></label>
                    <input list="roles" class="form-control fields" type="text" name="jobrole"/>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 form-group pt-0 inputStyle">
                    <label for="title">Job location<span style="color: red">*</span></label>
                    <v-autocomplete id="job_cities" v-model="t_city" label="Select location" :items="states" item-text="text" item-value="id" :searchable="true" @change="showSubcity" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template v-if= "typeof data.item" != "object">
                          <v-list-item-content v-text="data.item.text" />
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.text" />
                            <v-list-item-sub-title v-html="data.item.group" />
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="!toPost.cities.length && can_post != 0">Select Location</div>
                  </div>
                  <div class="col-lg-6 form-group inputStyle pt-0 pb-0" v-show="subCity">
                    <label for="title">Sub location</label>
                    <v-autocomplete v-model="t_location" label="Select sublocation" @change="setSublocations" :items="sublocations" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template v-if= "typeof data.item" !="object">
                          <v-list-item-content v-text="data.item.text" />
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.text" />
                            <v-list-item-sub-title v-html="data.item.group" />
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>

                  <div class="col-lg-6 form-group inputStyle pt-0 pb-0">
                    <label for="title">Qualification<span style="color: red">*</span></label>
                    <v-autocomplete id="job_courses" v-model="t_courses" label="Select qualification" :searchable="true" item-text="text" item-value="id" @change="getBranches" :items="courses" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template v-if= "typeof data.item" !="object">
                          <v-list-item-content v-text="data.item.text" />
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.text" />
                            <v-list-item-sub-title v-html="data.item.group" />
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="!toPost.courses.length && can_post != 0">Select Qualification</div>
                  </div>
                  <div class="col-lg-6 form-group inputStyle pt-0 pb-0" v-show="branches.length != 0">
                    <label for="title">Branch</label>
                    <v-autocomplete v-model="t_branches" style="white-space:break-spaces" label="Select course" @input="setBranches" :searchable="true" :items="branches" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template v-if= "typeof data.item" !="object">
                          <v-list-item-content v-text="data.item.text" />
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.text" />
                            <v-list-item-sub-title v-html="data.item.group" />
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <h2 class="h2st1 text-left mt-2 mb-4">Salary per month</h2>
                <div class="row form-label-group">
                  <div class="col-lg-6 inputStyle2">
                    <label for="title">Minimum<span style="color: red">*</span></label>
                    <input id="salary_min" class="form-control fields" v-model="toPost.jobs.salary_range_from" type="number" placeholder=" " @keydown.space.prevent/>
                    <div class="job_error" v-if="typeof validate.response.min_salary != 'undefined' && !validate.response.min_salary.val">{{ validate.response.min_salary.msg }}</div>
                  </div>
                  <div class="col-lg-6 inputStyle2">
                    <label for="title">Maximum</label>
                    <input id="salary_max" class="form-control fields" v-model="toPost.jobs.salary_range_to" type="number" placeholder=" " @keydown.space.prevent/>
                    <div class="job_error" v-if=" typeof validate.response.max_salary != 'undefined' && !validate.response.max_salary.val && toPost.jobs.salary_range_to">{{ validate.response.max_salary.msg }}</div>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <h2 class="h2st1 text-left mt-2 mb-4">Experience</h2>
                <div class="row form-label-group">
                  <div class="col-lg-6 inputStyle" id="experience_min">
                    <label for="title">Minimum<span style="color: red">*</span></label>
                    <v-select name="experiencemin" v-model="toPost.jobs.experience_from" :items="exp" item-value="value" item-text="text" clearable outlined deletable-chips></v-select>
                    <div class="job_error" v-if="!toPost.jobs.experience_from && can_post != 0">Enter minimum experience</div>
                  </div>
                  <div class="col-lg-6 inputStyle" id="experience_max">
                    <label for="title">Maximum</label>
                    <v-select name="experiencemax" v-model="toPost.jobs.experience_to" :items="exp" item-text="text" item-value="value" clearable outlined deletable-chips></v-select>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <div class="row form-label-group mt-0">
                  <div class="col-lg-6 pb-0 inputStyle">
                    <label class="fz">Job type<span style="color: red">*</span></label>
                    <v-select id="job_type" v-model="default_type" label="Select type" height="55px" name="jobtype" :items="job_type" item-value="value" item-text="text" clearable outlined chips @change="setJobType"></v-select>
                    <div class="job_error" style="margin-top: -25px; margin-bottom: 12px" v-if="!toPost.jobs.job_type && can_post != 0">Select Job type</div>
                  </div>
                  <div class="col-lg-6 inputStyle pb-0">
                    <label class="fz">Hiring Process<span style="color: red">*</span></label>
                    <v-select id="hire_process" name="hireprocess" label="Select hiring process" v-model="default_hiring" :items="hire_process" item-text="text" item-value="text" @change="setHiringProcess" clearable chips outlined multiple deletable-chips></v-select>
                    <div class="job_error" style="margin-top: -25px" v-if="!toPost.jobs.hiring_process.length && can_post != 0"> Select Hiring process</div>
                  </div>
                </div>
                <div class="row form-label-group mt-6">
                  <div class="col-lg-12 inputStyle2">
                    <!-- <div style="display:flex;justify-content:space-between;"> -->
                      <label for="title">Job description<span style="color: red">*</span></label>
                      <button type="button" class="text-primary" style="float:right;text-decoration: underline;cursor: pointer;padding-right: 20px;" @click="openTemplateModal()">Choose Templates</button>
                    <!-- </div> -->
                    <vue-editor id="job_desc" v-model="toPost.jobs.job_description" placeholder="Write a detailed job description with clear job responsibilities, expectations, criteria, and compensation details etc in simple language.Job posts with detailed Job descriptions of more than 200 characters attract more matching applications. " class="editor" @input="validate.checkIfEmpty(toPost.jobs.job_description,'description','Enter Description')"></vue-editor>
                      <div class="job_error" v-if=" typeof validate.response.description != undefined && can_post != 0">{{ validate.response.description.msg }}</div>
                  </div>
                </div>
              </div>

              <!-- <div class="row form-group">
                  <div class="col-lg-12">
                    Add Questionnaires to job <span class="btn btn-outline-primary ml-3" data-toggle="modal" data-target="#questionaire">Add</span>
                  </div>
                </div> -->

              <div class="morinfobtn text-right">
                <button type="button" @click="addMore()" class="btn btn-outline-primary">
                  <span v-show="!moreInfo"> + </span><span v-show="moreInfo">- </span>Additional information
                </button>
              </div>

              <div id="myDIV" style="display: block" v-show="moreInfo">
                <div class="mb-7 p-4 bg-white boxRadius">
                  <h2 class="h2st1 text-left mt-2 mb-4">More information</h2>
                  <div class="row inputStyle2 form-label-group mt-4">
                    <div class="col-lg-6">
                      <label class="fz">No of vaccancies</label>
                      <input class="form-control fields" v-model="toPost.jobs.number_of_vacancy" type="number" name="vaccancies"/>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Highest qualification %</label>
                      <input class="form-control form-group fields" v-model="toPost.jobs.hq_marks_percentage_from" type="number" min="0" max="100" name="hqmark">
                      <div v-if="toPost.jobs.hq_marks_percentage_from < 0 || toPost.jobs.hq_marks_percentage_from > 100" class="text-danger">Please enter a value between 0 and 100.</div>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="fz">Year of passing (From)</label>
                      <v-autocomplete v-model="toPost.jobs.year_of_passing_from" name="passout" :items="years" item-value="value" item-text="text" outlined></v-autocomplete>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Year of passing (To)</label>
                      <v-autocomplete v-model="toPost.jobs.year_of_passing_to" name="passout" :items="years" item-value="value" item-text="text" outlined></v-autocomplete>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row inputStyle form-label-group">
                    <div class="col-lg-6">
                      <label class="fz">Skills required</label>
                      <!-- <input list="skills" class="form-control fields" type="text" name="skills"> -->
                      <!-- <select name="skills" id="skills"></select> -->
                      <v-select v-model="t_skills" :searchable="true" @input="setSkills" :items="skills" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips></v-select>
                      <!-- <input id="job_skill" class="form-control fields" v-model="t_skills" type="text" placeholder="Select skill" list="skills" @input="setSkills">
                        <datalist id="skills">
                          <option :key="item.value" v-for="item in skills">{{item.text}}</option>
                        </datalist>  -->
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Gender</label>
                      <v-select v-model="toPost.jobs.gender" name="gender" :items="gender" item-value="value" item-text="text" clearable outlined deletable-chips></v-select>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row inputStyle2 form-label-group mt-4">
                    <div class="col-lg-6" style="display: none">
                      <label class="fz">Candidate current location</label>
                      <select name="location" id="location"></select>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Last date of Application / Interview</label>
                      <input class="form-control fields" v-model="toPost.jobs.last_date" :min="new Date().toISOString().slice(0,10)"  type="date" name="lastdate"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-7 p-4 bg-white boxRadius2 shadow2">
                <div class="row inputStyle2 form-label-group mt-4">
                  <div class="col-lg-12">
                    <label class="fz">Company name<span style="color: red">*</span></label>
                    <input id="job_company" class="form-control fields" v-model="toPost.jobs.company_name" type="text" name="cname"/>
                    <div class="job_error" v-if="!toPost.jobs.company_name && can_post != 0">Enter Company</div>
                  </div>
                </div>
                <div class="row form-label-group mt-4" v-if="activeJobfair">
                  <div class="col-lg-6 form-group mb-0">
                    <label class="fz">Post job in<span style="color: red">*</span></label>
                    <v-radio-group v-model="toPost.job_custom.job_fair_display" class="mt-0">
                      <v-radio label="Hireclap only" :value="1"></v-radio>
                      <v-radio label="Jobfair only" :value="2"></v-radio>
                      <v-radio label="Both" :value="3"></v-radio>
                    </v-radio-group>
                  </div>
                </div>
                <!-- </div> -->
                <div class="row inputStyle mt-4 form-label-group" v-if="activeJobfair && (toPost.job_custom.job_fair_display == 2 || toPost.job_custom.job_fair_display == 3)">
                  <div class="col-lg-6 form-group mb-0">
                    <v-autocomplete id="jobfairs" v-model="selected_jobfairs" label="Choose jobfair" :items="jobfairs" item-text="text" item-value="id" :searchable="true" clearable chips outlined multiple deletable-chips hide-selected>
                      <template slot="item" slot-scope="data">
                        <template v-if= "typeof data.item" !="object">
                          <v-list-item-content v-text="data.item.text" />
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.text" />
                            <v-list-item-sub-title v-html="data.item.group" />
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="!selected_jobfairs.length > 0 &&(toPost.job_custom.job_fair_display == 2 || toPost.job_custom.job_fair_display == 3) && can_post != 0"> Choose atlease one jobfair</div>
                  </div>
                </div>
                <div v-if="!is_login">
                  <div class="row inputStyle2 mt-4 form-label-group">
                    <div class="col-lg-6">
                      <label class="fz" id="client_email">Official Email Id<span style="color: red">*</span></label>
                      <input class="form-control fields" id="popover-button-sync" v-model="user.email" @input="validate.emailValidation(user.email, 'email')" type="text" name="u_email" v-on:blur.prevent="checkEmail" @keydown.space.prevent> 
                      <div class="error-feedback" v-if="(typeof validate.response.email != 'undefined' && !validate.response.email.val)">{{ validate.response.email.msg }}</div>
                    </div>
                    <b-popover :show.sync="show" placement="top" target="popover-button-sync" title="">
                      <div class="email_popover_close" @click="show=false">x</div>
                      Recommend entering your official email id, as it helps to verify your job postings faster. (Eg:-Yourname@Company.com)
                    </b-popover>
                    <div class="col-lg-6">
                      <label class="fz">Password<span style="color: red">*</span></label>
                      <input class="form-control fields" id="client_pass" v-model="user.password" @input="validate.passwordValidation(user.password, 'password')" type="password" name="u_password"/>
                      <div class="job_error" v-if="password_error">{{ password_error_msg }}</div>
                      <div class="error-feedback" v-if="typeof validate.response.password != 'undefined' &&!validate.response.password.val ">{{ validate.response.password.msg }}</div>
                    </div>
                  </div>
                  <div v-if="notRegistered">
                    <div class="row">
                      <div class="col-lg-6">
                        <label class="fz">Account type<span style="color: red">*</span></label>
                        <v-autocomplete id="client_type" v-model="user.acctype" :items="acctype.options" item-value="value" item-text="text" :class="{'is-invalid':typeof validate.response.acctype != 'undefined' &&!validate.response.acctype.val}" @input="validate.checkIfEmpty(user.acctype,'acctype','Select Account Type')" clearable outlined></v-autocomplete>
                        <div class="error-feedback" v-if="typeof validate.response.acctype != 'undefined' &&!validate.response.acctype.val">{{ validate.response.acctype.msg }}</div>
                      </div>
                      <div class="col-lg-6">
                        <label class="fz">Company name<span style="color: red">*</span></label>
                        <input id="client_company" class="form-control fields" v-model="user.cname" @input="validate.checkIfEmpty(user.cname,'cname','Enter Company name')" type="text" name="company_name"/>
                        <div class="error-feedback" v-if="typeof validate.response.cname != 'undefined' &&!validate.response.cname.val">{{ validate.response.cname.msg }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <label class="fz">Contact person name<span style="color: red">*</span></label>
                        <input id="client_name" class="form-control fields" v-model="user.cpname" @input="validate.checkIfEmpty(user.cpname,'cpname','Enter contact person name') " type="text" name="cp_name"/>
                        <div class="error-feedback" v-if="typeof validate.response.cpname != 'undefined' &&!validate.response.cpname.val">{{ validate.response.cpname.msg }}</div>
                      </div>
                      <div class="col-lg-6">
                        <label class="fz">Mobile<span style="color: red">*</span></label>
                        <input id="client_mobile" class="form-control fields" v-model="user.mob" @input="validate.mobileValidation(user.mob, 'tel')" type="text" name="u_email"/>
                        <div class="error-feedback" v-if="(typeof validate.response.tel != 'undefined' &&!validate.response.tel.val) ||(can_post > 0 && !validate.response.tel.val)"> {{ validate.response.tel.msg }}</div>
                        <div class="error-feedback" v-if="mobile_error">{{ mob_msg }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <label class="fz">City<span style="color: red">*</span></label>
                        <v-autocomplete id="client_city" v-model="user.city" label="" :items="states" @input = "validate.checkIfEmpty(user.city,'city','Select City')" item-text="text" item-value="id" :searchable="true" clearable outlined deletable-chips>
                          <template slot="item" slot-scope="data">
                            <template v-if= "typeof data.item" != "object">
                              <v-list-item-content v-text="data.item.text" />
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title v-html="data.item.text" />
                                <v-list-item-sub-title v-html="data.item.group"/>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <div class="error-feedback" v-if="typeof validate.response.city != 'undefined' &&!validate.response.city.val">{{ validate.response.city.msg }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="height: 30px"></div>
                <div class="gap20"></div>
                <div class="form-group">
                  <input type="checkbox" name="acceptterms" checked="checked" required=""/>I accept Hireclap
                  <a class="text-decoration-none" href="/privacy">privacy policy</a>&amp;<a class="text-decoration-none" href="/terms">terms &amp; conditions *</a><br />
                  <div class="gap20"></div>
                  <p><span class="text-danger">⚠</span> Asking jobs seeker for any kind of payment is strictly prohibited.</p>
                </div>
                <div class="gap20"></div>
                <div class="row form-group">
                  <div class="col-lg-12">
                    <button class="btn btn-primary" type="submit" @click="postJob" v-if="!isPosting" :disabled="high_usage && is_login"> &nbsp; Post job &nbsp;</button>
                    <button class="btn btn-outline-primary" v-if="isPosting">&nbsp; Posting... &nbsp;</button>
                    <div class="job_error" v-if="post_error">Error in some fields, please scroll up, correct & resubmit</div>
                  </div>
                </div>
              </div>
            </form>
            <div class="mb-7 p-4 bg-white boxRadius2 shadow2 faq">
              <h5>Free job posting - Frequently asked questions</h5>
              <div class="question expnd" v-b-toggle.collapse-a>How to post a free job in Hireclap?</div>
              <b-collapse id="collapse-a" class="answer">
                <p> It's easy - Click on the “Post Free Job “ button, enter the job detail and submit the job posting. Our moderators will review your job post and activate.You can view the job publishing status in the employer dashboard also.</p>
              </b-collapse>
              <div class="question expnd" v-b-toggle.collapse-b>How to make job posting attractive for job seekers?</div>
              <b-collapse id="collapse-b" class="answer">
                <p> Mention all relevant details about the job. It's better to mention responsibilities, expectations from the company and criteria clearly in simple language keeping the job seekers in mind.</p>
                <p> Mention an apt job title, salary offered, detailed job responsibilities, hiring locations, eligibility criteria, selection process, last date to apply, etc. Mention all relevant content about the job role. Mention about the company, career progression opportunities, etc for better traction.</p>
                <p> Jobs with detailed job descriptions above 300 characters received 3 times more job applications than a job posting with less than 300 characters JD with only a few bullet pointers (Report based on Hireclap job application statistics analysis in FY 21-22)</p>
              </b-collapse>
              <div class="question expnd" v-b-toggle.collapse-c>How does Hireclap ensure responses for a job posting?</div>
              <b-collapse id="collapse-c" class="answer">
                <p> The active jobs will be visible to Hireclap 3 million+ active jobseekers. Also, job seekers will be alerted with matching job opportunities. This will ensure quick responses from eligible candidates.</p>
                <p> If your hiring numbers are big & need to close on a very short time span, you can subscribe to our recruitment services.Write to recruit@hireclap.com / call +91 9037 156 526 for more details</p>
              </b-collapse>
              <div class="question expnd" v-b-toggle.collapse-d>Is there any cost involved in the job posting?</div>
              <b-collapse id="collapse-d" class="answer">
                <p> It's absolutely free. You can post unlimited jobs at Hireclap.com</p>
              </b-collapse>

              <button class="readmore t-color" v-if="readmore == false" @click="readmore=true">↻ Read more FAQ</button>
              <div v-if="readmore == true">
                <div class="question expnd" v-b-toggle.collapse-e>How long does it take for a job posting to get approved?</div>
                <b-collapse id="collapse-e" class="answer">
                  <p> Your job will be activated within 24hrs under normal circumstances.You can check the job publishing status on your account dashboard also.</p>
                </b-collapse>
                <div class="question expnd" v-b-toggle.collapse-f>For how many days, does a job posting is visible on the portal?</div>
                <b-collapse id="collapse-f" class="answer">
                  <p> During job posting, if you have entered the last date of application, then till that date. Else it will be up in our portal for 30 days from the date of posting.</p>
                </b-collapse>
                <div class="question expnd" v-b-toggle.collapse-g>How should I write a good job description?</div>
                <b-collapse id="collapse-g" class="answer">
                  <p> Details day to day responsibilities of the position in simple english <br /> When you are writing job description - Think like a jobseeker<br /> Mention the expectations, required criteria clearly Suggest to mention salary & other benefits</p>
                </b-collapse>
                <div class="question expnd" v-b-toggle.collapse-h>Where I can see my posted jobs & its responses?</div>
                <b-collapse id="collapse-h" class="answer">
                  <p> You can see the posted jobs & its responses in Manage jobs section
                    <a href="https://www.hireclap.com/recruit/client-job-dashboard" target="noopener" >https://www.hireclap.com/recruit/client-job-dashboard</a>
                  </p>
                  <p>Login into employer zone
                    <a href="https://www.hireclap.com/recruit/login" target="noopener" >https://www.hireclap.com/recruit/login</a> This will reciret to Manage jobs dashboard.You can find all posted jobs, responses, Status( Pending, Active etc), Option to View /Edit job , Job posted date , Expiry date etc
                  </p>
                </b-collapse>
                <div class="question expnd" v-b-toggle.collapse-i>How to make changes in a job posting?</div>
                <b-collapse id="collapse-i" class="answer">
                  <p> Login to employer account. In Employer dashboard > manage jobs section > against each job title there is an edit option (Click on the right hand 3 dots to access the edit option). The job edit will review by admin and reflect the changes made, post the admin approval.</p>
                </b-collapse>
                <div class="question expnd" v-b-toggle.collapse-j>Can I post job without registration?</div>
                <b-collapse id="collapse-j" class="answer">
                  <p>
                    Yes, You can post the job directly
                    <a href="https://www.hireclap.com/recruit/post-job" target="noopener" >https://www.hireclap.com/recruit/post-job</a>
                    with out prior registering to the site
                  </p>
                </b-collapse>
                <div class="question expnd" v-b-toggle.collapse-k>Does Hireclap collect any fee from candidates?</div>
                <b-collapse id="collapse-k" class="answer">
                  <p> No, Hireclap does not collect any fee from candidates. Also, we will not publish the jobs asking for money from candidates. Kindly do not post content asking for money from candidates at any stages of the hiring process.</p>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 rightarea">
          <div class="mb-7 p-4 bg-white boxRadius2 font-small">
            <div>
              <div v-if="is_login">
                <p v-if="high_usage"> We have found higher usage in your account.For security reasons we are deactivating your package.If this usage from your side, please contact admin at <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a> to activate your package</p>

                <!-- <p v-if="job_post_remaining > 0">Job postings left: {{job_post_remaining}}</p>
              <p v-else>No package to post jobs. Contact admin at <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a> for subscriptions</p> -->
              </div>

              <h6 class="mb-2"><strong>Why post jobs on Hireclap.com?</strong></h6>
              <ul class="listStyle1">
                <li>Free job posting platform</li>
                <li>Free access to all job applicant's profile</li>
                <li>Post jobs easily in a single step</li>
                <li>Advance response dashboard</li>
                <li>Send messages/ E call letters to applicants</li>
                <li>Online assessment integrated</li>
                <li>Questionnaires to filter matching applicants</li>
                <li>Job posts to reach 3 million+ active job seekers</li>
                <li>5000+ companies using the Hireclap platform</li>
              </ul>
              <hr class="divider1" />
              <h6 class="mb-2"><strong>Need support?</strong></h6>
              <p>Write to<a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a><br />Call +91 9037 156 256</p>
              <hr class="divider1" />
              <h6 class="mb-2"><strong>Job posting guidelines</strong></h6>
              <p> The following guidelines will help you to post jobs that are in line with standard job posting practices.Job posting that do not meet the standards may be subject to detailed review and may require additional details from hiring company to publish.Jobs that are not convinced represent a real job, misleading contents may be removed from listing.</p>
              <p> Please note the below guidelines, not a comprehensive list of what is allowable or forbidden.</p>
              <ul class="listStyle2">
                <li>Post only real and active job opportunities</li>
                <li>Use a proper job title & detailed job description</li>
                <li> Mention the eligibility criteria ,responsibilities, hiring locations</li>
                <li>Suggest to mention compensation and other benefits</li>
                <li>Donot post jobs that is not yours</li>
                <li>Donot post any in inapproappriate / offensive content</li>
                <li>Donot post jobs asking for payment from candidates</li>
                <li>Use the applicants data only for your recruitment purposes-maintain data privacy</li>
              </ul>
              <p> If you have any doubts about these guidelines, do reach out to us at recruit@hireclap.com</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="jobPostInfo">
          <h5><strong>Free job posting sites in India for employers </strong></h5>
          <p>Post free jobs at <a href="www.hireclap.com">Hireclap.com</a> - largest video profile based job site in India for entry level jobs. Post your jobs now and receive faster applications from our 3 million+ active jobseekers database.</p>
          <p><a href="www.hireclap.com">Hireclap.com</a> is one of the top free job posting sites in India. 5000+companies listed their jobs & hired candidates from us.Companies/Employers/Recruiters can post free jobs and can use the platform to schedule interviews for the job applicants. Recruiters can manage jobs, view applications through online job response dashboard. Recruiters can save hiring time by posting job in less than 30 seconds and managing your jobs application via realtime dashboard. Through Hireclap.com your can publish jobs across India and hire from nearby city or from your preferred location. Post your job now & close your open positions fatster.</p>
        </div>
      </div>
    </div>
    <b-modal id="job-success" ref="job-success" size="md" title=" " body-bg-variant="primary" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Job Posted Successfully</div>
    </b-modal>
    <b-modal id="description-template" ref="description-template" size="lg" title="STANDARD TEMPLATE" bod hide-footer hide-backdrop centered>
      <div class="container">
        <p>Select from the below existing templates that matches you job role</p>
        <div class="row">
          <div class="col-md-6">
            <v-autocomplete placeholder="Select preferred jobrole" @input="getTemplates" :items="jobroles" item-text="text" item-value="value" v-model="jobrole" outlined></v-autocomplete>
          </div>
        </div>
        <div v-if="jobrole && templates.length > 0" class="row">
          <div class="col-md-3 col-xs-12 templateNameSection">
            <v-radio-group v-model="selectedTemplate"  column class="col-3">
              <v-radio v-for="(template,index) in templates" :key="index" color="primary" :label="template.template_name" :value="template">
              </v-radio>
            </v-radio-group>
          </div>
          <div class="col-md-9 col-xs-12 template-content">
            <span class="content" v-html="selectedTemplate.content" v-if="selectedTemplate"></span>
          </div>
          <button class="btn btn-primary" v-on:click.prevent="chooseTemplate" v-if="selectedTemplate">Choose Template</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
var faqJson = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How to post a free job in Hireclap?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> It's easy - Click on the “Post Free Job “ button, enter the job detail and submit the job posting. Our moderators will review your job post and activate.You can view the job publishing status in the employer dashboard also.</p>"
        }
      }, {
        "@type": "Question",
        "name": "How to make job posting attractive for job seekers?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "p> Mention all relevant details about the job. It's better to mention responsibilities, expectations from the company and criteria clearly in simple language keeping the job seekers in mind.</p><p> Mention an apt job title, salary offered, detailed job responsibilities, hiring locations, eligibility criteria, selection process, last date to apply, etc. Mention all relevant content about the job role. Mention about the company, career progression opportunities, etc for better traction.</p><p> Jobs with detailed job descriptions above 300 characters received 3 times more job applications than a job posting with less than 300 characters JD with only a few bullet pointers (Report based on Hireclap job application statistics analysis in FY 21-22)</p>"
        }
      }, {
        "@type": "Question",
        "name": "How does Hireclap ensure responses for a job posting?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> The active jobs will be visible to Hireclap 3 million+ active jobseekers. Also, job seekers will be alerted with matching job opportunities. This will ensure quick responses from eligible candidates.</p><p> If your hiring numbers are big & need to close on a very short time span, you can subscribe to our recruitment services.Write to recruit@hireclap.com / call +91 9037 156 526 for more details</p>"
        }
      }, {
        "@type": "Question",
        "name": "Is there any cost involved in the job posting?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": " <p> It's absolutely free. You can post unlimited jobs at Hireclap.com</p>"
        }
      },{
        "@type": "Question",
        "name": "How long does it take for a job posting to get approved?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> Your job will be activated within 24hrs under normal circumstances.You can check the job publishing status on your account dashboard also.</p>"
        }
      }, {
        "@type": "Question",
        "name": "For how many days, does a job posting is visible on the portal?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> During job posting, if you have entered the last date of application, then till that date. Else it will be up in our portal for 30 days from the date of posting.</p>"
        }
      },{
        "@type": "Question",
        "name": "How should I write a good job description?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> Details day to day responsibilities of the position in simple english <br /> When you are writing job description - Think like a jobseeker<br /> Mention the expectations, required criteria clearly Suggest to mention salary & other benefits</p>"
        }
      },{
        "@type": "Question",
        "name": "Where I can see my posted jobs & its responses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> You can see the posted jobs & its responses in Manage jobs section<a href='https://www.hireclap.com/recruit/client-job-dashboard'>https://www.hireclap.com/recruit/client-job-dashboard</a></p><p>Login into employer zone<a href='https://www.hireclap.com/recruit/login'>https://www.hireclap.com/recruit/login</a> This will reciret to Manage jobs dashboard.You can find all posted jobs, responses, Status( Pending, Active etc), Option to View /Edit job , Job posted date , Expiry date etc</p>"
        }
      },
      {
        "@type": "Question",
        "name": "How to make changes in a job posting?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> Login to employer account. In Employer dashboard > manage jobs section > against each job title there is an edit option (Click on the right hand 3 dots to access the edit option). The job edit will review by admin and reflect the changes made, post the admin approval.</p>"
        }
      },
      {
        "@type": "Question",
        "name": "Can I post job without registration?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Yes, You can post the job directly<a href='https://www.hireclap.com/recruit/post-job' >https://www.hireclap.com/recruit/post-job</a>with out prior registering to the site</p>"
        }
      },
      {
        "@type": "Question",
        "name": "Does Hireclap collect any fee from candidates?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p> No, Hireclap does not collect any fee from candidates. Also, we will not publish the jobs asking for money from candidates. Kindly do not post content asking for money from candidates at any stages of the hiring process.</p>"
        }
      },
    ]
  }
export default {
  name: "JobPost",
  components: {
    VueEditor,
  },
  metaInfo: {
    script: [
      {type: 'application/ld+json', json: faqJson}
    ]
  },
  beforeMount() {
    // if(this.$route.query.jobfair) this.toPost.job_custom.job_fair_display = 2;
    this.getDesignations();
    this.getStates();
    this.getcourse();
    this.getYears();
    this.checkForActiveJobfairs();
    // this.getBranches();
    this.getJobroles();
    this.is_login = this.$cookies.get("hire-employer") ? true : false;
    this.getSkills();
    if (this.is_login) this.getJobPostQuota();
    if (this.$route.params.id) {
      this.getJobDetails(
        this.$route.params.id,
        this.$route.params.type,
        this.$route.params.user_id
      );
    }
  },
  mounted() {
    let data = this.$cookies.get("hire-employer");
    if (data) {
      new this.$apiAction().getEmployer(data.token).then((res) => {
        if (res.error == 0) {
          this.toPost.jobs.client_user_id =
            res.data.client_users.client_user_id;
          this.toPost.jobs.posted_by_id = res.data.client_users.client_user_id;
          this.toPost.jobs.company_name = res.data.client_name;
          this.disabled = true;
        }
      });
    }
  },
  data() {
    return {
      activeJobfair: false,
      selected_jobfairs: [],
      jobfairs: [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      validate: new this.$valid(),
      default_type: { value: 1, text: "Full time" },
      default_hiring: [{ value: 4, text: "Virtual hiring" }],
      toPost: {
        jobs: {
          client_user_id: null,
          date_of_posting: new Date(),
          job_designation: "",
          company_name: "",
          // last_date: new Date(new Date().setDate(new Date().getDate() + 30)).toLocaleDateString(),
          last_date: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().slice(0,10),
          job_type: 1,
          hiring_process: ["Virtual Hiring"],
          job_description: "",
          priority: 1,
          seo_title: null,
          seo_description: null,
          seo_keywords: null,
          response_type: 1,
          posted_by_id: null,
          salary_range_from: "",
          salary_range_to: null,
          job_role: null,
          salary_flag: 0,
          hq_marks_percentage_from: 0,
          number_of_vacancy: null,
          experience_from: null,
          experience_to: null,
          year_of_passing_from: null,
          year_of_passing_to: null,
        },
        job_custom: {
          organic_status: 1,
          mode: 1,
          job_fair_display: 1,
          src: null,
        },
        courses: [],
        cities: [],
        branches: [],
        categories: [],
        skills: [],
        sublocations: [],
      },
      t_city: null,
      t_location: null,
      t_cities: [],
      t_courses: [],
      t_branches: [],
      t_skills: [],
      city: [],
      moreInfo: false,
      designations: [],
      subCity: false,
      sublocations: [],
      post_job: false,
      metro_cities: [],
      states: [],
      courses: [],
      branches: [],
      skills: [],
      user_login: false,
      registered: false,
      disabled: false,
      can_post: 0,
      exp: [
        { value: 1, text: "0 Month(Fresher)" },
        { value: 6, text: "06 Months" },
        { value: 12, text: "1 Year" },
        { value: 24, text: "2 year" },
        { value: 36, text: "3 year" },
        { value: 48, text: "4 year" },
        { value: 60, text: "5 year" },
        { value: 72, text: "6 year" },
        { value: 84, text: "6+ year" },
      ],
      gender: [
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        { value: 3, text: "Both" },
      ],
      hire_process: [
        { value: 1, text: "Face to Face" },
        { value: 2, text: "Online assessment" },
        { value: 3, text: "Telephonic" },
        { value: 4, text: "Virtual hiring" },
        { value: 5, text: "Walk In" },
        { value: 6, text: "Written Test" },
      ],
      job_type: [
        { value: 1, text: "Full time" },
        { value: 2, text: "Work from home" },
        { value: 3, text: "Hybrid" },
        { value: 4, text: "Part time" },
        { value: 5, text: "Internship" },
        { value: 6, text: "Apprenticeship" },
      ],
      user: {
        email: null,
        password: null,
        acctype: 1,
        cname: null,
        cpname: null,
        mob: null,
        city: null,
        src: null,
      },
      high_usage: false,
      jobDetails: null,
      job: null,
      is_login: false,
      isLogin: false,
      notRegistered: false,
      password_error_msg: "",
      password_error: false,
      mobile_error: false,
      mob_msg: "",
      acctype: {
        options: [
          { value: 1, text: "Employer" },
          { value: 2, text: "Consultant" },
          { value: 4, text: "Institute" }
        ],
      },
      isPosting: false,
      job_post_remaining: 0,
      readmore: false,
      post_error: false,
      show:false,
      years:[],
      jobrole:null,
      jobroles:[],
      templates:[],
      selectedTemplate:{},
    };
  },
  methods: {
    checkForActiveJobfairs: function () {
      new this.$apiAction()
        .activeJobfairExists()
        .then((res) => {
          console.log("active jobfairs", res);
          if (res.status == true) {
            this.activeJobfair = true;
            this.toPost.job_custom.job_fair_display = 3;
            this.getJobfairs();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getYears(){
      var year = new Date().getFullYear();
      for(var i = year-30; i <year; i++){
        this.years.push({value:i, text:i});
      }
      for(i = year; i<=year+1; i++){
        this.years.push({value:i, text:i});
      }
    },
    getJobfairs: function () {
      // let token = this.$cookies.get("hire-employer").token;
      new this.$apiAction()
        .getJobfairs()
        .then((res) => {
          console.log("jobfairs", res);
          if (res.status == true) {
            res.jobfairs.forEach((element) => {
              {
                this.jobfairs.push({
                  text: element.job_fair_name,
                  id: element.id,
                });
              }
            })
          }else{
            this.toPost.jobs.job_role = 30;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openModal: function (type = "") {
      this.open = type == "" ? this.open : type;
      if (this.open == "success") {
        this.$refs["job-success"].show();
      }
    },
    getDesignations: function () {
      this.designations = [];
      new this.$apiAction().getJobDesignations().then((res) => {
        res.jobdesignations.forEach((e) => {
          this.designations.push({
            value: e.designation_id,
            text: e.designation,
            role_id: e.role_id,
          });
        });
      });
    },
    getJobPostQuota: function () {
      var token = this.$cookies.get("hire-employer").token;
      new this.$apiAction()
        .getFeatureQuota(process.env.VUE_APP_JOB_POST_FEATURE_ID, token)
        .then((res) => {
          if (res.status) {
            this.high_usage = res.high_usage;
            this.job_post_remaining = res.remaining_total;
          }
        });
    },
    getJobRole: function () {
      // console.log(this.toPost.jobs.job_designation);
      var flag = 0;
      this.designations.forEach((desig) => {
        if (desig.text == this.toPost.jobs.job_designation) {
          new this.$apiAction().getJobrole().then((res) => {
            res.jobroles.forEach((jobrole) => {
              if (jobrole.role_id == desig.role_id) {
                flag = flag + 1;
                this.toPost.jobs.job_role = jobrole.role_id;
              }
            });
            if (flag == 0) {
              this.toPost.jobs.job_role = 30; //set jobrole to 'others'
            }
          });
        }
      });
    },
    getJobroles(){
      new this.$apiAction().getJobrole().then(res => {
        res.jobroles.forEach(jobrole =>{
          this.jobroles.push({value:jobrole.role_id,text:jobrole.role});
        })
      })
    },
    getStates: async function () {
      await new this.$apiAction().getStates().then(async (data) => {
        this.states.push({ header: "Top Metropolitan Cities" });
        await data.states.forEach(async (element) => {
          await element.cities.forEach((city) => {
            if (city.top_city == 1) {
              this.states.push({
                text: city.city_name,
                id: city.city_id,
                s_id: city.state_id,
                group: "Top Metropolitan Cities",
              });
            }
          });
          this.states.push({ divider: true });
          this.states.push({ header: element.state_name });
          element.cities.forEach((city) => {
            if (city.top_city == 0) {
              this.states.push({
                text: city.city_name,
                id: city.city_id,
                s_id: city.state_id,
                group: element.state_name,
              });
            }
          });
        });
        this.states.push({
          text: "Anywhere india",
          id: 5000,
          s_id: 36,
          group: "Anywhere india",
        });
      });
    },
    showSubcity: function () {
      this.subCity = false;
      this.toPost.cities = [];
      this.sublocations = [];
      this.t_city.forEach((city) => {
        this.toPost.cities.push({ city_id: city });
        this.getSubCities(city);
      });
    },
    getSubCities: function (city_id) {
      var check = true;
      new this.$apiAction().getSubcity(city_id).then((data) => {
        if (data.sublocations) {
          this.subCity = true;
          data.sublocations.forEach((element) => {
            if (check == true) {
              this.sublocations.push({
                header: element.city_name,
              });
              check = false;
            } else {
              this.sublocations.push({
                value: element.sublocation_id,
                text: element.sublocation_name,
                city_id: city_id,
              });
            }
          });
        } else if (this.sublocations.length) {
          this.subCity = true;
        } else {
          this.subCity = false;
        }
      });
    },
    setSublocations: function () {
      this.toPost.sublocations = [];
      this.t_location.forEach((data) => {
        this.toPost.sublocations.push({ sublocation_id: data });
      });
    },
    getcourse: async function () {
      await new this.$apiAction().getCourse().then(async (data) => {
        this.courses.push({ header: "Popular Courses" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 1 &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 1 && element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "Popular Courses",
            });
          }
        });
        this.courses.push({ divider: true });
        this.courses.push({ header: "PG Courses" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 0 &&
              element.course_type == "pg" &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 0 &&
              element.course_type == "pg" &&
              element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "PG Courses",
            });
          }
        });
        this.courses.push({ divider: true });
        this.courses.push({ header: "Graduation Courses" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 0 &&
              element.course_type == "graduation" &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 0 &&
              element.course_type == "graduation" &&
              element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "Graduation Courses",
            });
          }
        });
        this.courses.push({ divider: true });
        this.courses.push({ header: "Other Category" });
        await data.courses.forEach((element) => {
          if (
            (element.popular_rating == 0 &&
              element.course_type == "others_category" &&
              element.course_id <= 5001 &&
              element.course_id != 37) ||
            (element.popular_rating == 0 &&
              element.course_type == "others_category" &&
              element.course_id == 5013)
          ) {
            this.courses.push({
              text: element.course_name,
              id: element.course_id,
              group: "Other Category",
            });
          }
        });
      });
    },
    getBranches: function () {
      this.branches = [];
      this.toPost.courses = [];
      var check = true;
      this.t_courses.forEach((data) => {
        this.toPost.courses.push({ course_id: data });
      });
      this.toPost.courses.forEach((course) => {
        new this.$apiAction().getSpec(course.course_id).then((data) => {
          check = true;
          if (data.specifications) {
            data.specifications.forEach((element) => {
              if (check == true) {
                this.branches.push({
                  header: element.course_name,
                });
                this.branches.push({
                  value: element.bid,
                  text: element.branch_name,
                });
                check = false;
              } else {
                this.branches.push({
                  value: element.bid,
                  text: element.branch_name,
                });
              }
            });
          }
          // data.specifications.forEach((element) => {
          //   this.branches.push({
          //     value: element.bid,
          //     text: element.branch_name,
          //   });
          // });
        });
      });
    },
    setBranches: function () {
      this.toPost.branches = [];
      this.t_branches.forEach((branch) => {
        this.toPost.branches.push({ branch_id: branch });
      });
    },
    setJobType: function () {
      if (this.default_type) {
        this.toPost.jobs.job_type = this.default_type;
      } else {
        this.toPost.jobs.job_type = "";
      }
    },
    setHiringProcess: function () {
      this.toPost.jobs.hiring_process = this.default_hiring;
    },
    hideSalary: function (e) {
      this.toPost.jobs.salary_flag = e.target.checked ? 1 : 0;
    },
    addMore: function () {
      this.moreInfo = !this.moreInfo;
    },
    getSkills: function () {
      this.skills = [];
      new this.$apiAction()
        .getSkills()
        .then((data) => {
          data.skills.forEach((element) => {
            this.skills.push({
              value: element.id,
              text: element.skill,
              slug: element.slug,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openTemplateModal(){
      this.$refs['description-template'].show();
    },
    setSkills: function () {
      this.toPost.skills = [];
      this.t_skills.forEach((skill) => {
        this.toPost.skills.push({ skills_id: skill });
      });
    },
    checkEmail() {
      new this.$apiAction().checkEmail(this.user.email).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.notRegistered = true;
        } else {
          this.notRegistered = false;
        }
      });
    },
    getTemplates() {
      new this.$apiAction().getDescriptionTemplate(this.jobrole).then((res)=>{
        if(res.status == true) {
          console.log(res);
          res.templates.forEach(template => {
            this.templates.push(template);
          });
        }
      });
    },
    chooseTemplate(){
      this.toPost.jobs.job_description = this.selectedTemplate.content;
      this.$refs['description-template'].hide();
    },
    postJob: function (e) {
      e.preventDefault();
      if (this.is_login && this.high_usage) return false;
      var city = null;
      this.can_post = 0;
      this.post_error = false;
      this.isPosting = true;
      var scrolledY;
      if (!this.toPost.jobs.job_designation) {
        this.can_post++;
      }
      if (this.toPost.cities.length == 0) {
        this.can_post++;
      }
      if (this.toPost.courses.length == 0) {
        this.can_post++;
      }
      if(this.validate.salaryValidation(this.toPost.jobs.salary_range_from, "min_salary")?.val === false){
        this.can_post++;
      }
      if(this.validate.salaryValidation(this.toPost.jobs.salary_range_to, "max_salary")?.val === false && this.toPost.jobs.salary_range_to){
        this.can_post++;
      }
      if(!this.toPost.jobs.experience_from){
        this.can_post++;
      }
      if (this.selected_jobfairs.length == 0 &&(this.toPost.job_custom.job_fair_display == 2 || this.toPost.job_custom.job_fair_display == 3)) {
        this.can_post++;
      }
      if (!this.toPost.jobs.job_type) {
        this.can_post++;
      }
      if (this.toPost.jobs.hiring_process.length == 0) {
        this.can_post++;
      }
      if (this.validate.checkIfEmpty(this.toPost.jobs.job_description,"description","Enter Description")?.val === false) {
        this.can_post++;
      }
      if (this.toPost.jobs.company_name == "") {
        this.can_post++;
      }
      if (this.toPost.jobs.hq_marks_percentage_from < 0 || this.toPost.jobs.hq_marks_percentage_from > 100) {
        this.can_post++;
      }
      if (this.can_post === 0) {
        this.states.forEach((data) => {
          if (data.id && data.id == this.toPost.cities[0]?.city_id) {
            city = data.text;
          }
        });
        let jobTypeText = "";
        this.job_type.forEach(type => {
          if (type.value === this.toPost.jobs.job_type) {
            jobTypeText = type.text;
          }
        });

        // Get qualification text
        let qualificationText = [];
        this.t_courses.forEach(courseId => {
          this.courses.forEach(course => {
            if (course.id === courseId) {
              qualificationText.push(course.text);
            }
          });
        });
        this.toPost.job_custom.src = this.$route.query.src ? this.$route.query.src: "home-post";
        this.toPost.jobs.seo_title = this.toPost.jobs.job_designation + " jobs in " + city + " at " + this.toPost.jobs.company_name;
        this.toPost.jobs.seo_description = `Apply for ${this.toPost.jobs.job_designation} jobs in ${city} at ${this.toPost.jobs.company_name}. ${jobTypeText} role for ${qualificationText.join('/')} candidates. Apply now on Hireclap.`;
        this.toPost.jobs.seo_keywords = [this.toPost.jobs.job_designation,city,this.toPost.jobs.company_name].join();
        this.toPost.jobs.hiring_process = this.toPost.jobs.hiring_process && typeof this.toPost.jobs.hiring_process != "string"? this.toPost.jobs.hiring_process.join(): typeof this.toPost.jobs.hiring_process == "string"? this.toPost.jobs.hiring_process: null;
        // this.toPost.jobs.year_of_passing_from = this.toPost.jobs .year_of_passing_from ? this.toPost.jobs.year_of_passing_from.split("-")[0] : null;
        // this.toPost.jobs.year_of_passing_to = this.toPost.jobs .year_of_passing_to ? this.toPost.jobs.year_of_passing_to.split("-")[0] : null;
        this.toPost.jobs.salary_range_to = this.toPost.jobs.salary_range_to ? this.toPost.jobs.salary_range_to : null;
        if (this.toPost.jobs.experience_from == 1) {
          this.toPost.jobs.experience_from = 0;
        }
        if (this.toPost.jobs.experience_to == 1) {
          this.toPost.jobs.experience_to = 0;
        }
        if (this.is_login) {
          let token = this.$cookies.get("hire-employer").token;

          new this.$apiAction().jobPost(this.toPost, token).then((res) => {
            if (res.error == 0) {
              this.isPosting = false;
              // this.job_post_remaining = res.remaining_total;
              
                  // console.log(res.)
                  if(this.selected_jobfairs.length > 0){
                    this.addJobs(res.data.job_id);
                  } else {
                    this.$router.push({name:'questionnaire',params:{'status':true,id:res.data.job_id},query:{role:this.toPost.jobs.job_role,version:'draft',user:this.toPost.jobs.client_user_id}});
                  }
              }else {
              console.log("empty field", this.can_post,);
            }
          }).catch((err) => {
            this.isPosting = false;
            console.log(err);
          });
        } else {
          if (this.validate.emailValidation(this.user.email, "email")?.val ===false) {
            this.can_post++;
          }
          if (this.validate.passwordValidation(this.user.password, "password")?.val === false ) {
            this.can_post++;
          }

          if (this.notRegistered) {
            if (this.validate.mobileValidation(this.user.mob, "tel")?.val ===false) {
              this.can_post++;
            }
            if (this.validate.checkIfEmpty(this.user.cname,"cname","Enter Company name")?.val === false) {
              this.can_post++;
            }
            if (this.validate.checkIfEmpty(this.user.cpname,"cpname","Enter Contact person name")?.val === false) {
              this.can_post++;
            }
            if (this.validate.checkIfEmpty(this.user.acctype,"acctype","Select Account Type")?.val === false) {
              this.can_post++;
            }
            if (this.validate.checkIfEmpty(this.user.city, "city", "Select City")?.val === false) {
              this.can_post++;
            }

            if (this.can_post === 0) {
              this.postJobWithoutLogin();
            } else {
              this.isPosting = false;
              this.post_error = true;
              if (this.validate.emailValidation(this.user.email, "email")?.val ===false) {
                document.getElementById('client_email').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }else if (this.validate.passwordValidation(this.user.password, "password")?.val === false ) {
                document.getElementById('client_pass').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }else if (this.validate.checkIfEmpty(this.user.acctype,"acctype","Select Account Type")?.val === false) {
                document.getElementById('client_type').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }else if (this.validate.checkIfEmpty(this.user.cname,"cname","Enter Company name")?.val === false) {
                document.getElementById('client_company').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }else if (this.validate.checkIfEmpty(this.user.cpname,"cpname","Enter Contact person name")?.val === false) {
                document.getElementById('client_name').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }else if (this.validate.mobileValidation(this.user.mob, "tel")?.val ===false) {
                document.getElementById('client_mobile').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }else if (this.validate.checkIfEmpty(this.user.city, "city", "Select City")?.val === false) {
                document.getElementById('client_city').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }
            }
          } else {
            if (this.can_post === 0) {
              this.postJobWithoutLogin();
            } else {
              this.isPosting = false;
              this.post_error = true;
              if (this.validate.emailValidation(this.user.email, "email")?.val ===false) {
                document.getElementById('client_email').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }else if (this.validate.passwordValidation(this.user.password, "password")?.val === false ) {
                document.getElementById('client_pass').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }
            }
          }
        }
      }else{
        this.isPosting = false;
        this.post_error = true;
        if (!this.toPost.jobs.job_designation) {
          document.getElementById('job_title').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.cities.length == 0) {
          document.getElementById('job_cities').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.courses.length == 0) {
          document.getElementById('job_courses').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if(this.validate.salaryValidation(this.toPost.jobs.salary_range_from, "min_salary")?.val === false){
          document.getElementById('salary_min').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if(this.validate.salaryValidation(this.toPost.jobs.salary_range_to, "max_salary")?.val === false && this.toPost.jobs.salary_range_to){
          document.getElementById('salary_max').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if(this.validate.checkIfEmpty(this.toPost.jobs.experience_from, "min_exp")?.val === false){
          document.getElementById('experience_min').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (!this.toPost.jobs.job_type) {
          document.getElementById('job_type').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.jobs.hiring_process.length == 0) {
          document.getElementById('hire_process').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.validate.checkIfEmpty(this.toPost.jobs.job_description,"description","Enter Description")?.val === false) {
          document.getElementById('job_desc').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.toPost.jobs.company_name == "") {
          document.getElementById('job_company').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }else if (this.selected_jobfairs.length == 0 &&(this.toPost.job_custom.job_fair_display == 2 || this.toPost.job_custom.job_fair_display == 3)) {
          document.getElementById('jobfairs').scrollIntoView(true);
          scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - 110);
          }
        }
      }
      },
      addJobs: function(job_id, redirect = true) {
        let data = [];
        let token = this.$cookies.get("hire-employer").token;
        this.selected_jobfairs.forEach(jobfair => {
            data.push({job_fair_id: jobfair,job_id: job_id});
        });
        new this.$apiAction().addJobs(data, token).then((res) => {
          if(res.status == true ) {
            if(redirect) {
              this.$router.replace({name:'recruiter_dashboard',params:{success:'Your job has been posted successfully , it will be active within the next 24 hrs'}});
              window.scrollTo(0, 0);
              location.reload();
            } else {
              new this.$apiAction().empLogout(token).then(res => {
                if(res.status == '1'){
                  this.$cookies.remove("hire-employer");
                  this.$router.push({name:'rec_login',params:{success_msg:'The job has been posted successfully. You can login now.'}});
                  // this.$router.push("/recruit/login");
                }
              })
            }
          }
        }).catch((err) => {
            console.log(err)
        });
      },
      getJobDetails(id,type,u_id){
        new this.$apiAction().getJobDetails({id:id,type:type, user_id:u_id}).then(res => {
          this.toPost.jobs = res.data.jobs;
          // this.job = res.data.jobs;
          this.toPost.job_custom = res.data.job_custom;
          res.data.branches.forEach((branch) => {
            this.toPost.branches.push({ branch_id: branch });
            this.t_branches.push(branch);
          });
          // res.data.categories.forEach(category => {
          //   this.toPost.categories.push({category_id:category})
          //   // this.t_.push(category)
          // })
          res.data.cities.forEach((city) => {
            this.toPost.cities.push({ branch_id: city });
            this.t_city = { id: city, text: "malappuram" };
          });
          res.data.courses.forEach((course) => {
            this.toPost.courses.push({ course_id: course });
            this.t_courses.push({ value: course, text: "10th Pass (SSC)" });
          });
          res.data.skills.forEach((skill) => {
            this.toPost.skills.push({ branch_id: skill });
            this.t_skills.push(skill);
          });
          res.data.sublocations.forEach((subloc) => {
            this.toPost.sublocations.push({ branch_id: subloc });
            this.t_location.push(subloc);
          });
        });
    },
    postJobWithoutLogin() {
      var scrolledY;
      try {
        this.toPost.job_custom.src = this.$route.query.src? this.$route.query.src: "home-post";
        this.user.src = this.$route.query.src ? this.$route.query.src : null;
        new this.$apiAction().postWithoutAuth(this.toPost, this.user).then((res) => {
            this.isPosting = false;
            if (res.message == "Posted Successfully") {
              if (this.selected_jobfairs.length > 0) {
                const employer = { token: res.data.token, name: res.data.name };
                this.$cookies.set("hire-employer", employer);
                this.addJobs(res.data.job_id, false);
              } else {
                if(res.data['created']) {
                   this.$router.push({name:'rec_login',params:{success_msg:'Registration successful. You can login now.'}});
                } else this.$router.push({name:'rec_login',params:{success_msg:'Your job has been posted successfully, it will be active within the next 24 hrs'}});
              }
            } else if (res.message == "Employer Registration Failed!") {
              this.post_error = true;
              this.auth_error = true;
              this.auth_msg = "Registration failed";
            } else if (res.message == "Password incorrect") {
              this.post_error = true;
              this.password_error = true;
              this.password_error_msg = "Password incorrect";
              if (this.validate.emailValidation(this.user.email, "email")?.val ===false) {
                document.getElementById('client_pass').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }
            } else if (res.mob !== undefined) {
              this.post_error = true;
              this.mobile_error = true;
              this.mob_msg = res.mob[0];
              if (this.validate.emailValidation(this.user.email, "email")?.val ===false) {
                document.getElementById('client_mobile').scrollIntoView(true);
                scrolledY = window.scrollY;
                if(scrolledY){
                  window.scroll(0, scrolledY - 110);
                }
              }
            } else {
              console.log("other error");
              this.post_error = true;
            }
          });
      } catch (err) {
        this.isPosting = false;
        this.post_error = true;
        console.log(err);
      }
    },
  }
};
</script>

<style>
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
.template-content{
  height: 250px;
    overflow-y: scroll;
    text-align: left;
    border-left: 2px solid lightgrey;
}
</style>
